// extracted by mini-css-extract-plugin
module.exports = {"container":"ShirtColor_container__3LeEz","side":"ShirtColor_side__2Q4XF","shirtInputContainer":"ShirtColor_shirtInputContainer__3m6Ss"};